var _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconClipboard = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 16,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.188 7.069h5.625M5.188 9.412h5.625M5.188 11.756h5.625M10.344 3.313h2.344a.937.937 0 0 1 .937.937v9.844a.94.94 0 0 1-.937.937H3.313a.94.94 0 0 1-.938-.937V4.25a.937.937 0 0 1 .938-.937h2.343a2.344 2.344 0 0 1 4.688 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 3.32a.234.234 0 0 1 0-.47M8 3.32a.234.234 0 0 0 0-.47"
  }))));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 16,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: fill,
    stroke: stroke
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.188 7.069h5.625M5.188 9.412h5.625M5.188 11.756h5.625M10.344 3.313h2.344a.937.937 0 0 1 .937.937v9.844a.94.94 0 0 1-.937.937H3.313a.94.94 0 0 1-.938-.937V4.25a.937.937 0 0 1 .938-.937h2.343a2.344 2.344 0 0 1 4.688 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 3.32a.234.234 0 0 1 0-.47M8 3.32a.234.234 0 0 0 0-.47"
  }))));
});
export default SvgIconClipboard;
export const raw = __webpack_public_path__ + "static/media/IconClipboard.5dc7c361c77298b8246e4b305250460a.svg";